import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { Response } from "~types/response.ts";
import type { Roster } from "~types/roster";

type PersonInRosterType = {
  seasonId?: string;
  personId?: string;
};

export const useGetPersonRosterInfo = () => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  return useMutation<{ roster?: Roster; isPersonInRoster: boolean }, unknown, PersonInRosterType>({
    mutationFn: ({ seasonId, personId }: PersonInRosterType) => {
      const url = `${sport}/o/${organizationId}/seasons/${seasonId}/persons/${personId}/roster`;

      return request<Response<Roster>>(url, {
        method: "GET",
        onError: { 404: () => {} },
      })
        .then((response) => ({
          roster: response?.data?.[0],
          isPersonInRoster: response?.data?.length > 0,
        }))
        .catch(() => ({ isPersonInRoster: false }));
    },
  });
};
